<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="board clear">
            <div class="tab-list-wrap">
              <ul class="tab-list">
                <li class="on">사용 내역 조회</li>
              </ul>
              <div class="tab-slide">
                <div class="tab-slide-bg"></div>
                <div class="tab-slide-on"></div>
              </div>
            </div>

            <div class="viewer">
              <SearchConditions
                class="search-conditions"
                @search="search"
                @download="download"
              ></SearchConditions>

              <PayList
                class="pay-list"
                :searchCondition="searchCondition"
                :startTime="startTime"
                :endTime="endTime"
                :searchEvent="searchEvent"
                @download="download"
              ></PayList>

              <Download
                v-show="false"
                ref="download"
                class="download"
                :searchCondition="searchCondition"
              ></Download>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import SearchConditions from '@/components/payHistory/SearchConditions';
import PayList from '@/components/payHistory/PayList';
import Download from '@/components/Download';

export default {
  components: {
    Toolbar,
    Navigation,
    SearchConditions,
    PayList,
    Download,
  },
  data: () => ({
    menu: null,
    searchCondition: null,
    startTime: '',
    endTime: '',
    searchEvent: 0,
    menuInfo: {
      mainTitle: 'PayHistory',
      mainName: '결제 내역',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    search(condition, startTime, endTime) {
      this.searchCondition = condition;
      this.startTime = startTime;
      this.endTime = endTime;
      this.searchEvent ^= 1;
    },
    download() {
      this.$refs.download.downloadPayment();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/payHistory/PayHistory.vue